// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38VOu","col":"styles_col__uYkbn"};